const LeftSectionPanelTypes = {
  NONE:     'NONE',
  FDIC:     'FDICText',
  TEXT:     'TEXT',
  ADDRESS:  'ADDRESS BOX',
  HOUSING:  'EQUAL HOUSING',
  NCUA:     'NCUA',
  SHAPES:   'SHAPES',
  SVGIMAGE: 'SVGIMAGE',
  Image:    'Image',
  QRCODE:   'QRCode',
  Video:    'Video',
  Audio:    'Audio',
  GROUP:    'GROUP',
  TABLE:    'TABLE',
};

LeftSectionPanelTypes.Mixin = {
  created() {
    this.LeftSectionPanelTypes = LeftSectionPanelTypes;
  },
};
export default LeftSectionPanelTypes;
